// extracted by mini-css-extract-plugin
export default {"bckg":"header_bckg__sFIZ7","custm_logo":"header_custm_logo__lO2n9"};